var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard__connections" }, [
    _vm.hasConnections
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-7 mix__chart mix__chart--mfg"
            },
            [
              _c("ChartCustom", {
                staticClass: "chart__mix",
                attrs: {
                  "chart-settings": _vm.chartConfig,
                  "chart-height": _vm.height,
                  "chart-width": _vm.width,
                  "chart-donut-hole": 0.65
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-5 mix__chart mix__chart--mfg h-center-align"
            },
            [
              _c("table", { staticClass: "pieTable" }, [
                _vm.detailedConnections
                  ? _c(
                      "tbody",
                      [
                        _vm._l(_vm.detailedConnections, function(
                          connection,
                          index
                        ) {
                          return _c("tr", { key: index }, [
                            _c("td", { staticClass: "chartColor" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "chartColor__box",
                                  class: "chartColor__box--" + index
                                },
                                [_vm._v(" ")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "pieTable__key" }, [
                              _vm._v(_vm._s(connection.type))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "pieTable__value" }, [
                              _vm._v(_vm._s(connection.qty))
                            ])
                          ])
                        }),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td"),
                          _vm._v(" "),
                          _c("td", { staticClass: "pieTable__key" }, [
                            _vm._v("Time (hrs)")
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "pieTable__value" }, [
                            _vm._v(_vm._s(_vm.duration))
                          ])
                        ])
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ]
          )
        ])
      : _c("div", { staticClass: "row" }, [_vm._m(0)])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col connections__no-data" }, [
      _c("div", { staticClass: "connections__placeholder" }, [
        _c("img", { attrs: { src: "/images/Connections.svg" } })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "connections__placeholder h-grey-bg h-border-left" },
        [_vm._v("No data")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }